import loadable from '@loadable/component';
import themesQuery from './themes-query.graphql';

const ThemesPage = loadable(() =>
  import(/* webpackChunkName: "campaigns" */ './components/themes')
);

ThemesPage.graphQL = themesQuery;

ThemesPage.loadOrder = [];

ThemesPage.variables = () => ({});

export default ThemesPage;
